import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKey as useUserKey } from 'shared/hooks/queries/use-user-query';
import {
  getEmailByOobcode,
  resetPassword,
  signInUser,
  signOutUser,
} from 'shared/services/backend-api';
import { AuthFlowError } from 'shared/types/auth-flow-error';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';

export const useResetPasswordMutation = () => {
  const client = useQueryClient();

  return useMutation<
    void,
    AuthFlowError<ResetPasswordErrorTypes>,
    {
      password: string;
      code: string;
    }
  >({
    mutationFn: async ({ password, code }) => {
      // get email from the oobCode
      const email = await getEmailByOobcode(code);
      // sign out user before resetting the password to prevent problems with a potential logged-in user
      await signOutUser();
      // reset password
      await resetPassword(code, password);
      // login user
      await signInUser(email, password);
      // invalidate user
      await client.invalidateQueries({ queryKey: [useUserKey] });
    },
  });
};
